// extracted by mini-css-extract-plugin
module.exports = {"popup":"workplace-selector_popup__siF_G"};